import { useMutation } from "@tanstack/react-query";
import { apiV1 } from "api-v2";
import type { UserListItem } from "newui/features/Auth/types/userInvite";

interface RegisterPayload {
  registration_token: string;
  phone: string;
  password: string;
  password_confirmation: string;
}

interface RegisterResponse {
  user: UserListItem;
  access_token: string;
}

interface RegisterError {
  message: string;
  code?: string;
  errors?: Record<string, string[]>;
}

export const useRegisterMutation = () =>
  useMutation<RegisterResponse, RegisterError, RegisterPayload>({
    mutationFn: async (payload) => {
      const res = await apiV1.post<RegisterResponse>(
        "auth/invite/register",
        payload
      );
      return res.data;
    },
    retry: false,
  });
